const items = ["Fresh.", "Fun.", "Fueled by Nature.", "Made in Orlando.", "100% Natural.", "Made with Love."];

export default function Marquee() {
  const loop = [...items, ...items];
  return (
    <div className="relative border-y-2 border-ink/10 bg-leaf/10 py-4 overflow-hidden" data-testid="marquee">
      <div className="marquee-track">
        {loop.map((t, i) => (
          <span key={i} className="mx-6 flex items-center gap-6 whitespace-nowrap font-display text-2xl sm:text-4xl font-bold uppercase tracking-tight text-ink">
            {t}
            <span className="text-watermelon">✳</span>
          </span>
        ))}
      </div>
    </div>
  );
}
